import http from '@/utils/http'
import qs from 'qs'

export function code(areaCode,mobile) {
  return http({
  	url:'/code.do?areaCode='+areaCode+'&mobile='+mobile,
  	methos:'get'
  })
}

export function userLogin(username,password) {
return http({
	url:'/login.do?username='+username+'&password='+password,
	methos:'get'
})
}

//export function userLogin(username,password) {
//	const data = qs.stringify({username,password})
//	return http({
//  url: '/login.do',
//  method: 'post',
//  data
//})
//}

export function userLogout() {
	return http({
    url: '/logout.do',
    method: 'post'
  })
}

export function userForgetPwd(areaCode,mobile,code,password) {
  const data = qs.stringify({areaCode,mobile,code,password});
  return http({
  	url:'/reset.do',
  	method:'post',
  	data
  })
}

export function userRegister(username,randomcode,password) {
	const data = qs.stringify({username,randomcode,password})
	return http({
    url: '/signup.do',
    method: 'post',
    data
  })
}